<template>
  <v-container>
    <v-row class="pa-4 ma-0 contenedor align-content-center flex-wrap d-flex">
      <v-col
        align="center"
        justify="space-around"
        md="12"
        sm="12"
        class="pa-0 ma-0"
      >
        <h1>{{ $STR.tituloCentroAyuda }} {{ sProducto }}</h1>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 nav-contenedor-primary">
      <v-col lg="12" md="12" sm="12" class="pa-0 ma-0">
        <h5>
          <router-link :to="routeDashboard"
            >{{ $STR.navVistaPrincipal }}
          </router-link>
          > <b>{{ $STR.navModulo }} {{ sModulo }}</b>
        </h5>
      </v-col>
    </v-row>
    <v-row
      v-if="sToken != ''"
      class="pa-4 ma-0 titulo-contenedor align-content-center flex-wrap d-flex"
    >
      <v-col
        align="center"
        justify="space-around"
        md="12"
        sm="12"
        class="pa-0 ma-0"
      >
        <v-btn
          color="primary"
          elevation="2"
          medium
          rounded
          x-large
          @click="onClickAgregarMaterial()"
          >{{ $STR.btnAgregarMaterial }}</v-btn
        >
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 align-content-center flex-wrap d-flex">
      <v-col
        align="center"
        justify="space-around"
        lg="12"
        md="12"
        sm="12"
        class="pa-0 ma-0"
      >
        <h2>{{ $STR.navModulo }} {{ sModulo }}</h2>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col lg="12" md="12" sm="12" class="pa-0 ma-0">
        <v-data-iterator
          :items="onFiltroData"
          items-per-page.sync="5"
          hide-default-footer
        >
          <template v-slot:header>
            <v-row class="pa-4 ma-0">
              <v-col lg="12" md="12" sm="12" class="pa-4 ma-0">
                <v-select
                  v-model="aFiltro"
                  :items="aCategorias"
                  attach
                  chips
                  :label="sLabelFiltro"
                  multiple
                ></v-select>
              </v-col>
            </v-row>
          </template>

          <template v-slot:default="props">
            <v-row>
              <v-col
                class="pa-4 ma-0"
                v-for="item in props.items"
                :key="item.idBC_Preguntas"
                cols="12"
                sm="12"
                md="6"
                lg="4"
              >
                <v-card
                  @click="onCLickPregunta(item)"
                  elevation="6"
                  class="mx-auto"
                  outlined
                >
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle
                        >{{ item.Pregunta }} -
                        {{ item.Tecnologia }}</v-list-item-subtitle
                      >
                    </v-list-item-content>

                    <v-list-item-avatar>
                      <v-icon class="pa-4 ma-0" left>
                        fas fa-chevron-right
                      </v-icon></v-list-item-avatar
                    >
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axiosServices from "@/services/axiosServices.js";
// import { mixFunciones } from "@/mixins/funciones.js";

export default {
  name: "modulo-modulo-ayuda",
  // mixins: [mixFunciones],
  components: {},
  mounted() {
    this.onLoadData();
  },
  data() {
    return {
      routeDashboard:
        "/Inicio/centro-de-ayuda/dashboard/producto/" +
        sessionStorage.producto +
        "?tecnologia=" +
        sessionStorage.tecnologia +
        "&perfil=" +
        sessionStorage.perfil +
        "&usuario=" +
        sessionStorage.usuario +
        "&codigo=" +
        sessionStorage.codigo,
      cargando: false,
      sToken: this.$store.state.token,
      sIP: sessionStorage.ip,
      sProducto: "",
      sModulo: sessionStorage.sModulo,
      aPreguntasModulo: [],
      sLabelFiltro: this.$STR.phFiltroCategoria,
      aCategorias: [],
      aFiltro: []
    };
  },
  methods: {
    onLoadData() {
      this.cargando = true;
      axiosServices
        .getConfiguration( `/base_conocimientos/modulos/${this.$route.params.idModulo}/preguntas`, false, `app=${this.sApp}&token=${this.sToken}&tecnologia=${sessionStorage.tecnologia}&producto=${sessionStorage.producto}`
        )
        .then((aResponse) => {
          this.aPreguntasModulo = aResponse.aData;
          this.aPreguntasModulo.forEach((item) => {
            if (!this.aCategorias.includes(item.Categoria))
              this.aCategorias.push(item.Categoria);
          });
          this.cargando = false;
        });
    },
    onCLickPregunta(item) {
      sessionStorage.item = JSON.stringify(item);
      this.$router.push({
        path:
          "/Inicio/centro-de-ayuda/dashboard/producto/" +
          sessionStorage.producto +
          "/modulo/" +
          item.idBC_Modulos +
          "/pregunta/" +
          item.idBC_Preguntas,
      });
    },
    onClickAgregarMaterial() {
      this.$router.replace({ name: "NuevaPregunta" });
    },
  },
  computed: {
    onFiltroData(){
      if(this.aFiltro.length ==0){
        return this.aPreguntasModulo
      }else{
        return this.aPreguntasModulo.filter( item => this.aFiltro.includes(item.Categoria))
      }
    }
  }
};
</script>
